module.exports = __webpack_public_path__ + "slide-02.png?9d30523555d43c6311c5e9ba3bfc9a1e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slide-02.png
// module id = 396
// module chunks = 0